import React from 'react';
import App from './App';
// import {BrowserRouter, Routes, Route} from 'react-router-dom';
import {createRoot} from 'react-dom/client';

const domNode = document.getElementById('root');
const root = createRoot(domNode);
root.render(<App />);
